import styled from 'styled-components';

export const Title = styled.h6`
  color: #acacac;
`;

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Button = styled.div`
  margin-right: 20px;
`;

export const StatusBarWrapper = styled.div`
  width: 100%;
  padding: 20px 0 20px 20px;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  opacity: 1;
  color: #111111;
  z-index: 1;
  font-weight: 700;
  border-top: 5px solid #4b286d;
`;

export const DueMonthlyWrapper = styled.div`
  display: inline-block;
  padding: 0 20px 0 0;
  height: 100px;
  vertical-align: top;
`;

export const DueMonthlyText = styled.div`
  display: inline-block;
  margin: 0 -0.15em;
  padding: 0 20px 0 0;
`;

export const Amount = styled.div`
  display: inline-block;
  margin: 0 -0.15em;
`;

export const DueNowWrapper = styled.div`
  display: inline-block;
  margin: 0 -0.15em;
  padding: 0 20px;
  height: 100px;
  border-left: solid 1px #acacac;
  vertical-align: top;
`;

export const DueNowText = styled.div`
  display: inline-block;
  margin: 0 -0.15em;
  padding: 0 20px 0 0;
`;

export const ButtonsWrapper = styled.div`
  display: inline-block;
  margin: 0 -0.15em
  height: 100px;
  vertical-align: top;
`;

export const LabelDueMonthly = styled.div`
  color: #2a2c2e;
  word-wrap: break-word;
  font-size: 0.875rem;
  -webkit-letter-spacing: -0.6px;
  -moz-letter-spacing: -0.6px;
  -ms-letter-spacing: -0.6px;
  letter-spacing: -0.6px;
  line-height: 1.42857;
  font-weight: 500;
  display: block;
`;

export const BeforeTaxesLabel = styled.div`
  color: #2a2c2e;
  word-wrap: break-word;
  font-size: 0.875rem;
  -webkit-letter-spacing: -0.6px;
  -moz-letter-spacing: -0.6px;
  -ms-letter-spacing: -0.6px;
  letter-spacing: -0.6px;
  line-height: 1.42857;
  font-weight: 500;
`;

export const PricingBlockMain = styled.div`
  display: flex;
  float: none;
`;

export const IntegralPart = styled.span`
  font-size: 1.75rem;
  font-weight: 400;
  color: #2a2c2e;
`;

export const FractionalPart = styled.span`
  font-size: 1rem;
  top: -9.25px;
  position: relative;
  font-weight: 500;
`;

export const Currency = styled.span`
  position: relative;
  font-size: 1rem;
  top: 4.5px;
  -webkit-order: -1;
  -ms-flex-order: -1;
  order: -1;
  font-weight: 500;
  color: #2a2c2e;
`;
